












import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'

  @Component({
    name: 'BarHorizontal',
    components: { Chart }
  })
export default class extends Vue {
    @Prop({ default: '#00B66C' }) private color!: string
    @Prop({ required: true }) private dataList!: Array<any>
    private chartId: string = ''
    private yData: Array<string> = []
    private xData: Array<any> = []
    private markData: Array<any> = []
    // private lineData: Array<any> = []
    private option: any = {
      // animation: false,
      grid: {
        left: 100
        // show: false
        // containLabel: true
      },
      xAxis: {
        position: 'top',

        axisLine: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#999999'
        },
        name: '',
        max: 100
      },
      yAxis: {
        data: [],
        nameTextStyle: {
          fontSize: 10
        },
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      series: [
        {
          name: '均值',
          type: 'bar',
          data: [],
          label: {
            show: true,
            position: 'right',
            formatter: '{c}%'
          },
          itemStyle: {
            color: '#00B66C',
            barBorderRadius: 10
          },
          barWidth: 10
        }
      ]
    }

    get chart() {
      return this.$refs.chart as any
    }
    @Watch('dataList', { immediate: true, deep: true })
    onDataChange(val: any) {
      if (!this.dataList.length) return
      this.xData = []
      this.yData = []
      this.markData = []
      // this.xData.reverse()
      let barList = JSON.parse(JSON.stringify(this.dataList)).reverse()
      barList.map((item: any, index: number) => {
        // this.yData.push(item.classroomName.substring(0, 3))
        this.yData.push(item.name)
        // 均分
        let mean = parseFloat(item.values[0] || 0)
        // // 标准差
        // let standardDeviation = parseFloat(item.values[2] || 0)
        this.xData.push(mean || 0)
        // this.markData.push([index, mean - standardDeviation / 2, mean + standardDeviation / 2])
      })
      console.log(this.xData)
      console.log(this.yData)
      console.log(this.markData)
      this.option.yAxis.data = this.yData
      // x轴数据
      this.option.series[0].data = this.xData
      // 参考标准-常模
      // this.option.series[0].markLine.data[0].xAxis = barList[0].values[5]
      //
      // this.option.series[1].data = this.markData
      this.$nextTick(() => {
        this.setOption()
      })
    }
    created() {
      this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    }

    private setOption() {
      this.chart.setOption(this.option)
    }
}
